/* eslint-disable import/no-webpack-loader-syntax */
import { useEffect, useRef } from "react";
import mapboxgl from "!mapbox-gl";

const Marker = ({ map, feature, isActive, onClick }) => {
  const markerRefs = useRef([]);

  useEffect(() => {
    if (feature?.markers?.length > 0) {
      markerRefs.current = feature.markers.map((markerData, index) => {
        let markerClassName = isActive ? "marker-active" : "marker";
        if (feature?.isCompetitor) {
          markerClassName = "marker-competitor";
        } else if (feature?.isProspect) {
          if (feature?.areaStatus[index] === "AVAILABLE") {
            markerClassName = "marker-prospect marker-green";
          } else if (feature?.areaStatus[index] === "TO_SEIZE") {
            markerClassName = "marker-prospect marker-orange";
          } else {
            markerClassName = "marker-prospect marker-red";
          }
        }
        const markerElement = document.createElement("div");
        markerElement.className = markerClassName;
        markerElement.onclick = () => onClick(feature, index);

        return new mapboxgl.Marker(markerElement)
          .setLngLat(markerData.coordinates)
          .addTo(map);
      });
    }

    return () => {
      markerRefs.current.forEach((marker) => marker.remove());
    };
  }, [feature, isActive]);

  return null;
};

export default Marker;
